export const styles = theme => ({
  container: {
    width: 600,
    padding: `0 ${theme.spacing.unit * 2}px ${theme.spacing.unit * 2}px`
  },
  bookButton: {
    textAlign: 'right',
    marginTop: theme.spacing.unit * 2
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  disabled: { 
    opacity: 0.3,
    pointerEvents: 'none'
  }
})


// WEBPACK FOOTER //
// ./src/components/BookForm/styles.js